// ===== Interfaces =====

import {
    IReadPostItem,
} from '../interfaces';

const resolvePostPathFromScopeIds = ({
    post,
    chapterId,
    sectionId,
}: {
    post?: IReadPostItem,
    chapterId?: string,
    sectionId?: string,
}): number[] => {
    if (!post || !chapterId) {
        return [];
    }

    const chapterIndex = post.chapters?.findIndex((chapter) => chapter.id === chapterId) ?? -1;
    if (chapterIndex === -1) {
        return [];
    }

    if (!sectionId) {
        return [chapterIndex];
    }

    const sectionIndex = post.chapters?.[chapterIndex]?.sections?.findIndex((section) => section.id === sectionId) ?? -1;
    if (sectionIndex === -1) {
        return [chapterIndex];
    }

    return [chapterIndex, sectionIndex];
};

export default resolvePostPathFromScopeIds;
